import React from "react";
import { CircularProgress } from "@material-ui/core";
import './Loading.css';

const Loading: React.FC = () => {
    return (
        <div id="loading">
            <CircularProgress id="loadingIcon"  />
        </div>
    ); 
}

export default Loading;